module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.59345","quantity":0.01593},{"color":"#9dc4b5","label":" 1.59345- 1.81932","quantity":0.01819},{"color":"#e6efc3","label":" 1.81932- 2.40519","quantity":0.02405},{"color":"#ffe89e","label":" 2.40519- 3.27653","quantity":0.03277},{"color":"#f5af7f","label":" 3.27653- 4.64585","quantity":0.04646},{"color":"#ed6d32","label":" 4.64585- 14.39752","quantity":0.14398}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_80_return_10.json
// module id = plKV
// module chunks = 171